import {apiBaseClient, apiClient} from "@services/dataSource/lib/api";
import {API_URL} from "@/app/constants/apiUrlInfo";
import {
    AllSpaceBrandShopListGetPayload,
    BrandListForSpaceGetPayload, SpaceAllListGetPayload,
    SpaceBrandCodePayload, SpaceBrandGetPayload, SpaceBrandShopAllListGetPayload, ShopCopyPayload,
    SpaceGetPayload,
    SpaceListGetPayload,
    SpacePayload, ShopCopyProgressPayload
} from "@services/entities/spaceEntity";
import {DeletePayload} from "@services/entities/commonEntity";

// NEW :: space get list Api
export const SpaceListGetApi = async<T extends SpaceListGetPayload> (params: T): Promise<T['response']> => {
    return await apiClient.get(API_URL.space.base, {params});
}

// NEW :: brand get list for space code Api
export const BrandListForSpaceCodeGetApi = async<T extends BrandListForSpaceGetPayload> (params: T): Promise<T['response']> => {
    return await apiClient.get(API_URL.space.brandList, {params});
}

// NEW :: space get Api
export const SpaceGetApi = async<T extends SpaceGetPayload> (params: T): Promise<T['response']> => {
    return await apiClient.get(API_URL.space.base + '/' + params.id);
}

// NEW :: space brand code get Api
export const SpaceBrandCodeGetApi = async<T extends SpaceBrandCodePayload> (params: T): Promise<T['response']> => {
    return await apiClient.get(API_URL.space.base, {params});
}

// NEW :: space post Api
export const SpacePostApi = async<T extends SpacePayload> (data: T): Promise<T['response']> => {
    return await apiClient.post(API_URL.space.base, data);
}

// NEW :: space put Api
export const SpacePutApi = async<T extends SpacePayload> (data: T): Promise<T['response']> => {
    return await apiClient.put(API_URL.space.base+'/'+ data.id, data);
}

// NEW :: space delete Api
export const SpaceDeleteApi = async<T extends DeletePayload> (data: T): Promise<T['response']> => {
    return await apiClient.delete(API_URL.space.base, {data});
}

// NEW :: space delete Api
export const SpaceBrandGetApi = async<T extends SpaceBrandGetPayload> (data: T): Promise<T['response']> => {
    return await apiClient.get(API_URL.space.popup);
}

// NEW :: space all List Api
export const SpaceAllListGetApi = async<T extends SpaceAllListGetPayload> (params: T): Promise<T['response']> => {
    return await apiClient.get(API_URL.space.allList);
}

// NEW :: space brand shop All List Api
export const SpaceBrandShopAllListGetApi = async<T extends SpaceBrandShopAllListGetPayload> (params: T): Promise<T['response']> => {
    return await apiClient.get(API_URL.space.brandShop, {params});
}

export const AllSpaceBrandShopListGetApi = async<T extends AllSpaceBrandShopListGetPayload> (data: T): Promise<T['response']> => {
    return await apiClient.get(API_URL.space.target);
}

export const ShopCopyApi = async<T extends ShopCopyPayload> (data: T): Promise<T['response']> => {
    // shop 복사
    const targetShop = data?.targetShop;
    const sourceShop = data?.sourceShop;
    return await apiClient.put(`${API_URL.space.shopCopy}/${sourceShop}/${targetShop}`);
}

export const ShopCopyProgressApi = async<T extends ShopCopyProgressPayload> (params: T): Promise<T['response']> => {
    // shop 복사 진행률 확인 api (polling)
    const uuid = params?.uuid;
    return await apiClient.get(`${API_URL.space.shopCopyProgress}/${uuid}`);
}

export const SpaceBrandCodeGetApiInMyMenu = async<T extends SpaceBrandCodePayload> (params: T): Promise<T['response']> => {
    //2025.10.20 Master space 이동으로 생성
    return await apiBaseClient.get(API_URL.space.base, {params});
}